/**
 * maje-swipers.js
 * Inicializa los carruseles Swiper de las secciones "Maje products" y del cart drawer.
 * Re-inicializa cuando el editor de temas re-renderiza una sección (shopify:section:load),
 * y evita instancias duplicadas.
 */

function initMajeProductSectionSwiper(scope) {
  var root = scope || document;

  root.querySelectorAll('.maje-products .swiper').forEach(function (carousel) {
    // Evitar doble inicialización (Swiper 11 expone la instancia en el.swiper)
    if (carousel.swiper) {
      carousel.swiper.destroy(true, true);
    }

    var nextBtn = carousel.querySelector('.swiper-button-next');
    var prevBtn = carousel.querySelector('.swiper-button-prev');

    new Swiper(carousel, {
      loop: true,
      slidesPerView: 1,
      speed: 1000,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      }
    });
  });
}

function initCartDrawerCarousel() {
  var carousel = document.querySelector('.swiper.swiper-cart-drawer');
  if (!carousel) return;

  if (carousel.swiper) {
    carousel.swiper.destroy(true, true);
  }

  var nextBtn = carousel.querySelector('.swiper-button-next');
  var prevBtn = carousel.querySelector('.swiper-button-prev');

  new Swiper(carousel, {
    loop: true,
    slidesPerView: 1,
    speed: 1000,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn
    }
  });
}

initMajeProductSectionSwiper();
initCartDrawerCarousel();

/* --- Editor de temas: re-render de secciones --- */
document.addEventListener('shopify:section:load', function (e) {
  if (typeof Swiper === 'undefined') return;
  var section = e.target;
  if (section.querySelector('.maje-products .swiper')) {
    initMajeProductSectionSwiper(section);
  }
  if (section.querySelector('.swiper.swiper-cart-drawer')) {
    initCartDrawerCarousel();
  }
});

document.addEventListener('shopify:section:unload', function (e) {
  e.target.querySelectorAll('.swiper').forEach(function (carousel) {
    if (carousel.swiper) {
      carousel.swiper.destroy(true, true);
    }
  });
});
